import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "../../images/CloseIcon.svg";
import AdminLeaveContext from "../contextfolder/AdminLeaveContext/AdminLeaveContext";
import OrderContext from "../contextfolder/OrderContext/OrderContext";



export default function PayOrder({ handlePayFalse, handlePayTrue }) {

    const { payFormValue, setPayFormValue, payFormError, setPayFormError, isSubmit, setIsSubmit, payValue, deliveredWithPay, setDeliveredWithPay, tAmount } = useContext(OrderContext)

    const remainingAmount = payFormValue.payAmount - tAmount;

    const handleChange = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        setPayFormValue({ ...payFormValue, [name]: value });
    };


    const handleOnChange = (e) => {
        setDeliveredWithPay(!deliveredWithPay)
    };

    const validate = (values) => {

        const errors = {};
        if (!values.payAmount) {
            errors.payAmount = "Required";
        }

        return errors;
    };


    const formSubmit = (e) => {
        e.preventDefault();
        setPayFormError(validate(payFormValue));
        setIsSubmit(true);
    }


    useEffect(() => {
        if (Object.keys(payFormError).length === 0 && isSubmit) {
            handlePayTrue(payFormValue)
            setPayFormValue(payValue)
            setIsSubmit(false);
        }

    }, [payFormError]);



    return (
        <>
            <div className="container confirm-leave-popup">
                <div className="confirm-leave-popup-inner ">
                    <div className="popUpHeader ps-0 pe-0">
                        <div className="popUpDelTitle">Easy School</div>
                        <div className="popUpClose">
                            <img style={{ paddingRight: "10px", cursor: "pointer" }}
                                className="popUpCloseIcon"
                                src={CloseIcon}
                                alt="CloseIcon"
                                onClick={handlePayFalse}
                            />
                        </div>
                    </div>

                    <div className="confirm-pay-body  ps-3 pe-3">
                        <div className="row text-start ">
                            <div className="delText">Are you sure want to Pay this?</div>
                        </div>
                    </div>
                    <div className="container-fluid basicform">
                        <div className="form-group">
                            <div>
                                <b> Total Amount: {parseFloat(tAmount).toFixed(2)} </b>
                            </div>
                        </div>
                        <div className="form-row" style={{ marginTop: "10px" }}>

                            <div className="form-group col-md-6">
                                <label className="form-label" htmlFor="payAmount" style={{ fontSize: "12px" }}>
                                    Pay Amount<sup style={{ color: "red" }}>*</sup>
                                </label>
                                <input
                                    id="payAmount"
                                    style={{ fontSize: "13px" }}
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="payAmount"
                                    value={payFormValue.payAmount}
                                    onChange={handleChange}
                                />
                                <p className="errormsg " style={{ marginBottom: "0" }}>{payFormError.payAmount}</p>

                            </div>
                            <div className="form-group col-md-6">
                                <label className="form-label" style={{ fontSize: "12px" }}>
                                    Remaining Amount
                                </label>
                                <div>
                                    <input
                                        id="remainingAmount"
                                        style={{ fontSize: "13px" }}
                                        type="text"
                                        className="form-control form-control-sm "
                                        value={payFormValue.payAmount === "" ? 0 : remainingAmount}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="checkbox-close" style={{ marginLeft: "9px", paddingTop: "3px" }}>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="exampleCheck3"
                            name="notWorking"
                            onChange={handleOnChange}
                            checked={deliveredWithPay}
                        />
                        <label class="form-check-label" for="exampleCheck3" style={{ fontSize: "12px" }}>
                            Delivered
                        </label>
                    </div>

                    <div className="confirm-leave-footer">
                        <div className="row  mt-2 mb-2">
                            <div>
                                <button
                                    type="button"
                                    class="btn btn-sm me-2"
                                    style={{ background: "#0079bf", color: "white" }}
                                    onClick={formSubmit}
                                >
                                    Okay
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-danger me-3"
                                    style={{ color: "white" }}
                                    onClick={handlePayFalse}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

